<template lang="pug">
  img(src="/images/icons/wave.gif")
</template>

<script>
export default {}
</script>
